<template>
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.41943 16V10H10.4194V16H8.41943Z"
      fill="#A2B1C6"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.41943 16L2.41943 10H4.41943V16H2.41943Z"
      fill="#A2B1C6"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.4194 16V7H13.4194V16H11.4194Z"
      fill="#A2B1C6"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.4194 16V8H16.4194V16H14.4194Z"
      fill="#A2B1C6"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.41943 12V16H5.41943V12H7.41943Z"
      fill="#A2B1C6"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.4332 1.80676L16.6265 6.00001L15.9194 6.70712L12.4055 3.19326L5.93169 9.1691L1.71436
        5.55424L2.36515 4.79499L5.90707 7.83092L12.4332 1.80676Z"
      fill="#A2B1C6"
    />
  </svg>
</template>

<script>
export default {
  name: 'ChartIcon'
}
</script>
